export const randomUUID = () => {
	return crypto.randomUUID();
};